import type { RouteConfig } from 'vue-router';

const defaultMeta = {
  excludeLogin: true,
  background: '#fff',
};

export default [
  /**
   * 红包使用规则
   */
  {
    path: '/rules/red-packet',
    meta: {
      ...defaultMeta,
      title: '红包使用规则',
    },
    component: () => import('@/components/rules/red-packet.vue'),
  },
  /**
   * 还款返现券使用规则
   */
  {
    path: '/rules/repay-cash-back',
    meta: {
      ...defaultMeta,
      title: '还款返现券使用规则',
    },
    component: () => import('@/components/rules/repay-cash-back.vue'),
  },
  /**
   * 借款折扣券使用规则
   */
  {
    path: '/rules/loan-discount',
    meta: {
      ...defaultMeta,
      title: '借款折扣券使用规则',
    },
    component: () => import('@/components/rules/loan-discount.vue'),
  },
  /**
   * 提额券使用规则
   * 主要用于APP卡券中心
   */
  {
    path: '/rules/raise-credit-limit',
    meta: {
      ...defaultMeta,
      title: '提额券使用规则',
    },
    component: () => import('@/components/rules/raise-credit-limit.vue'),
  },
  /**
   * 人脸信息处理授权书
   */
  {
    path: '/rules/face-authorize',
    meta: {
      ...defaultMeta,
      title: '人脸信息处理授权书',
    },
    component: () => import('@/components/rules/face-authorize.vue'),
  },
  /**
   * 提款返现券
   * 主要用于APP卡券中心
   */
  {
    path: '/rules/loan-cash-back',
    meta: {
      ...defaultMeta,
      title: '提款返现券使用规则',
    },
    component: () => import('@/components/rules/loan-cash-back.vue'),
  },
  /**
   * 分期权益包规则说明
   */
  {
    path: '/rules/installment-rights-interests',
    meta: {
      ...defaultMeta,
      title: '礼包详情',
    },
    component: () => import('@/components/rules/installment-rights-interests.vue'),
  },
  /**
   * 广告主提现红包
   * 主要用于APP卡券中心
   */
  {
    path: '/rules/partner-loan-red-packet',
    meta: {
      ...defaultMeta,
      title: '借款红包使用规则',
    },
    component: () => import('@/components/rules/partner-loan-red-packet.vue'),
  },
  /**
   * 0息借款券
   * 主要用于APP卡券中心
   */
  {
    path: '/rules/zero-interest-loan-coupon',
    meta: {
      ...defaultMeta,
      title: '0息借款券使用规则',
    },
    component: () => import('@/components/rules/zero-interest-loan-coupon.vue'),
  },
  /**
   * 随借随还券
   * 主要用于APP卡券中心
   */
  {
    path: '/rules/anytime-repay-coupon',
    meta: {
      ...defaultMeta,
      title: '随借随还券使用规则',
    },
    component: () => import('@/components/rules/anytime-repay-coupon.vue'),
  },
  /**
   * 定价券(息费减免券)
   * 主要用于APP卡券中心
   */
  {
    path: '/rules/pricing-coupon',
    meta: {
      ...defaultMeta,
      title: '息费减免券使用规则',
    },
    component: () => import('@/components/rules/pricing-coupon.vue'),
  },
  /**
   * 借款减免券
   */
  {
    path: '/rules/discount-loan-coupon',
    meta: {
      ...defaultMeta,
      title: '免息券使用规则',
    },
    component: () => import('@/components/rules/discount-loan-coupon.vue'),
  },
  /**
   * 借款提额券
   */
  {
    path: '/rules/loan-increase-amount',
    meta: {
      ...defaultMeta,
      title: '提额券使用规则',
    },
    component: () => import('@/components/rules/loan-increase-amount.vue'),
  },
  /**
   * 分期折扣券
   */
  {
    path: '/rules/installment-discount-coupon',
    meta: {
      ...defaultMeta,
      title: '分期折扣券使用规则',
    },
    component: () => import('@/components/rules/installment-discount-coupon.vue'),
  },
  /**
   * 分期立减券
   */
  {
    path: '/rules/installment-reduce-coupon',
    meta: {
      ...defaultMeta,
      title: '分期立减券使用规则',
    },
    component: () => import('@/components/rules/installment-reduce-coupon.vue'),
  },
  /**
   * 自开发人脸识别验证服务授权书
   */
  {
    path: '/rules/self-developed-face-authorize',
    meta: {
      ...defaultMeta,
      title: '人脸识别验证服务协议',
    },
    component: () => import('@/components/rules/self-developed-face-authorize.vue'),
  },
] as RouteConfig[];
